/**
 * Copyright (c) Mik BRY
 * mik@mikbry.com
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 */
import Interface from '../../interface';
import Theme from '../../Theme';
import EmptyAvatar from '../EmptyAvatar';
import Avatar from '../Avatar';

const HeaderStyled = Interface.styled('header')`
  color: ${(props) => props.theme.palette.onPrimary};
  font-size: 1.25em;
  background: ${(props) => props.theme.palette.primary};
  padding: 0.75em;
  display: flex;
  align-items: center;
  
  & > .ziiircom-header-avatar {
    margin: 0;
    margin-right: 0.75em;
    width: 36px;
    height: 36px;
  }
  & > .ziiircom-header-title {
    font-weight: 500;
    line-height: 1.2em;
  }
  & > .ziiircom-header-title > h2 {
    margin: 0;
    font-size: 1em;
  }
  & > .ziiircom-header-title > span {
    font-size: 0.9em;
  }
  & > .ziiircom-header-buttons {
    margin-left: auto;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  @media only screen and (max-width: 772px) {
    .ziiircom-messenger header {
      border-radius: 0 !important;
    }
    .ziiircom-messenger header button.ziiircom-header-buttons-close-button {
      display: block !important;
    }
  }
`;

HeaderStyled.defaultProps = {
  theme: Theme,
};

const CloseBut = Interface.styled('button')`
width:24px;
height:24px;
padding: 6px;
border: none;
border-radius:100%;
display: ${(props) => (props.closeButton ? 'block' : 'none')};
background-color: rgba(255, 255, 255, 0.2);
&:hover {
  background-color: rgba(255, 255, 255, 0.4);
}
`;

const CloseIcon = Interface.styled('div')`
width:12px;
height:12px;
background: transparent;
background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cg fill='white'%3E%3Cpath d='M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z'/%3E%3C/g%3E%3C/svg%3E");
background-repeat:no-repeat;
background-position:50%;
background-size:cover;
cursor:pointer;
`;

CloseIcon.defaultProps = {
  theme: Theme,
};

const AboutBut = Interface.styled('button')`
width:24px;
height:24px;
padding: 2px;
border: none;
border-radius:100%;
display: ${(props) => (props.aboutButton ? 'block' : 'none')};
background-color: rgba(255, 255, 255, 0.2);
&:hover {
  background-color: rgba(255, 255, 255, 0.4);
}
`;

const AboutIcon = Interface.styled('div')`
width:20px;
height:20px;
background: transparent;
background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='160' width='160' viewBox='0 0 160 160'%3E%3Cg fill='white'%3E%3Cpath d='m80 15c-35.88 0-65 29.12-65 65s29.12 65 65 65 65-29.12 65-65-29.12-65-65-65zm0 10c30.36 0 55 24.64 55 55s-24.64 55-55 55-55-24.64-55-55 24.64-55 55-55z'/%3E%3Cpath d='m57.373 18.231a9.3834 9.1153 0 1 1 -18.767 0 9.3834 9.1153 0 1 1 18.767 0z' transform='matrix(1.1989 0 0 1.2342 21.214 28.75)'/%3E%3Cpath d='m90.665 110.96c-0.069 2.73 1.211 3.5 4.327 3.82l5.008 0.1v5.12h-39.073v-5.12l5.503-0.1c3.291-0.1 4.082-1.38 4.327-3.82v-30.813c0.035-4.879-6.296-4.113-10.757-3.968v-5.074l30.665-1.105'/%3E%3C/g%3E%3C/svg%3E");
background-repeat:no-repeat;
background-position:50%;
background-size:cover;
cursor:pointer;
`;

AboutIcon.defaultProps = {
  theme: Theme,
};

const ResetBut = Interface.styled('button')`
width:24px;
height:24px;
padding: 2px;
border: none;
border-radius:100%;
display: ${(props) => (props.resetButton ? 'block' : 'none')};
background-color: rgba(255, 255, 255, 0.2);
&:hover {
  background-color: rgba(255, 255, 255, 0.4);
}
`;

const ResetIcon = Interface.styled('div')`
width:20px;
height:20px;
background: transparent;
background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' width='24' viewBox='0 0 24 24'%3E%3Cg fill='white'%3E%3Cpath d='M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3-3 1.331-3 3 1.329 3 3 3z'/%3E%3Cpath d='M20.817 11.186a8.94 8.94 0 0 0-1.355-3.219 9.053 9.053 0 0 0-2.43-2.43 8.95 8.95 0 0 0-3.219-1.355 9.028 9.028 0 0 0-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 0 1 2.502 1.053 7.005 7.005 0 0 1 1.892 1.892A6.967 6.967 0 0 1 19 13a7.032 7.032 0 0 1-.55 2.725 7.11 7.11 0 0 1-.644 1.188 7.2 7.2 0 0 1-.858 1.039 7.028 7.028 0 0 1-3.536 1.907 7.13 7.13 0 0 1-2.822 0 6.961 6.961 0 0 1-2.503-1.054 7.002 7.002 0 0 1-1.89-1.89A6.996 6.996 0 0 1 5 13H3a9.02 9.02 0 0 0 1.539 5.034 9.096 9.096 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22a9.09 9.09 0 0 0 1.814-.183 9.014 9.014 0 0 0 3.218-1.355 8.886 8.886 0 0 0 1.331-1.099 9.228 9.228 0 0 0 1.1-1.332A8.952 8.952 0 0 0 21 13a9.09 9.09 0 0 0-.183-1.814z'/%3E%3C/g%3E%3C/svg%3E");
background-repeat:no-repeat;
background-position:50%;
background-size:cover;
cursor:pointer;
`;

ResetIcon.defaultProps = {
  theme: Theme,
};

const e = Interface.createElement;

const Header = ({
  title, subtitle, avatar,
  closeButton, closeButtonTitle, onClose,
  aboutButton, aboutButtonTitle, onAbout,
  resetButton, resetButtonTitle, onReset
}) => e(
    HeaderStyled,
    null,
    avatar ? e(Avatar, { className: 'ziiircom-header-avatar', src: avatar.src, alt: avatar.name }) : e(EmptyAvatar),
    e('div', { className: 'ziiircom-header-title' },
      e('h2', null, title),
      e('span', null, subtitle),
    ),
    e('div', { className: 'ziiircom-header-buttons' },
      e(CloseBut, { closeButton, onClick: onClose, className: 'ziiircom-header-buttons-close-button', title: closeButtonTitle }, e(CloseIcon)),
      e(AboutBut, { aboutButton, onClick: onAbout, className: 'ziiircom-header-buttons-about-button', title: aboutButtonTitle }, e(AboutIcon)),
      e(ResetBut, { resetButton, onClick: onReset, className: 'ziiircom-header-buttons-reset-button', title: resetButtonTitle }, e(ResetIcon)),
    )
);

export default Header;
